import { NavigateFunction, NavigateOptions, To, useNavigate } from 'react-router'

import { toRouter } from '../components/app/PSApplication'

// Wrapper around `useNavigate` so we can properly serialize classes as location state
export function usePSNavigate() {
    const rrNavigate = useNavigate()

    const navigate: NavigateFunction = (...args) => {
        if (typeof args[0] === 'number') {
            rrNavigate(args[0])
            return
        }

        if (args[1]) {
            const to = args[0] as To
            const opts = args[1] as NavigateOptions

            if (opts.state) {
                rrNavigate(to, { ...opts, state: toRouter(opts.state) })
                return
            }

            rrNavigate(to, opts)
            return
        }

        rrNavigate(args[0])
    }

    return navigate
}
